<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content bg-purple-light">
          <span>库存数据管理</span>
        </div>
      </el-col>
    </el-row>
    <el-form :inline="true" :model="queryParam" class="demo-form-inline" size="mini">
      <!-- <el-form-item label="来源库 ：">
        <el-checkbox-group v-model="selectOptionList" @change="selectOpWHChange">
          <el-checkbox v-for="(item, index) in whSelectOptions" :label="item.value" :key="index">{{ item.label }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->
      <el-form-item label="ISBN ：">
        <el-input v-model="queryParam.productSn" placeholder="ISBN"></el-input>
      </el-form-item>
      <el-form-item label="书名 ：">
        <el-input v-model="queryParam.productName" placeholder="图书名称"></el-input>
      </el-form-item>
      <el-form-item label="作者 ：">
        <el-input v-model="queryParam.author" placeholder="作者"></el-input>
      </el-form-item>
      <el-form-item label="出版社 ：">
        <el-input v-model="queryParam.providerName" placeholder="出版社"></el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox style="margin: 0 20px;" v-model="isStockNum">有库存</el-checkbox>
        <el-button type="primary" @click="handleClick" icon="el-icon-search">查询</el-button>
        <!-- <el-button type="success" @click="exportExcels" icon="el-icon-download">导出</el-button> -->
      </el-form-item>
    </el-form>
    <el-row align="bottom">
      <el-col :span="16">
        <el-pagination background @current-change="handleCurrentChangeSystem"
          :current-page="systemStockPage.currentPage" :page-size="systemStockPage.pagesize"
          :total="systemStockPage.pageTotal" layout="total,prev,pager,next"></el-pagination>
      </el-col>
    </el-row>
    <el-table :data="tableDataSys" v-loading="loading" row-key="id" stripe border ref="tableDataSys">
      <!-- <el-table-column property="supWarehouseCode" label="供应商" min-width="10"/> -->
      <el-table-column property="productSn" label="ISBN" min-width="30"></el-table-column>
      <el-table-column property="productName" label="图书名称"></el-table-column>
      <el-table-column property="author" label="作者" min-width="30"></el-table-column>
      <el-table-column property="providerName" label="出版社" min-width="20"></el-table-column>
      <el-table-column property="providerTime" label="出版时间" width="100"></el-table-column>
      <el-table-column property="position" label="库位" width="70"></el-table-column>
      <el-table-column property="marketPrice" label="定价" width="60"></el-table-column>
      <el-table-column property="costDiscount" label="进货折扣" width="100"></el-table-column>
      <el-table-column property="productNum" width="70" label="库存" />
      <!-- <el-table-column property="updateTime" label="更新时间" width="100"></el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getAction  } from "../../api/index";
import { selectOptionsList } from "../../utils/index";
export default {
  name: "whProductStock",
  provide() {
    return {
      parentQueryParam: this.queryParam
    }
  },
  data() {
    return {
      isStockNum: true,
      tableDataWh: [],
      tableDataSys: [],
      whSelectOptions: selectOptionsList(),
      selectOptionList: this.$store.state.selectOptionHbList,
      queryParam: {
        selectOption: "0",
        productSn: "",
      },
      url: {
        queryProductsList: "/productsWH/queryProductsStockList",
        queryWhProductsPage: "/productsWH/queryWhProductsPage",
      },
      whStockPage:{
        currentPage: 1, // 当前页码
        pagesize: 10, // 每页显示的行数
        pageTotal: 0,
      },
      systemStockPage:{
        currentPage: 1, // 当前页码
        pagesize: 10, // 每页显示的行数
        pageTotal: 0,
      },
    };
  },
  components: {
  },
  mounted() {},
  computed: {
    ...mapGetters(["isNaName"]),
  },
  created() {
    // console.log("this.$route.params :>> ", this.$route.params);
    // this.activeName = this.$route.params.flag;
    this.handleClick()
  },
  methods: {
    selectOpWHChange(val) {
      console.log("供应商选择搜索框val :>> ", val, this.wh.selectOptionList);
    },
    handleClick(isPage) {
      if ('0' === this.queryParam.selectOption) {
        if(isPage !== 1) this.systemStockPage.currentPage = 1;
        this.getGoodsList(this.systemStockPage)
      } else {
        // this.getGoodsList(this.whStockPage)
        this.getWhGoodsList(this.whStockPage)
      }
    },
    handleCurrentChangeWh(val){
      this.whStockPage.currentPage = val;
      this.handleClick()
    },
    handleCurrentChangeSystem(val){
      this.systemStockPage.currentPage = val;
      this.handleClick(1)
    },
    getGoodsList(page) {
      this.loading = true;
      const that = this
      that.queryParam.pageNo = page.currentPage
      that.queryParam.pageSize = page.pagesize
      that.queryParam.warehouseId = that.$store.state.userInfo.id,
      that.queryParam.productNum = that.isStockNum ? 1 : 0;
      getAction(that.url.queryProductsList, that.queryParam).then((res) => {
          that.loading = false;
        if (res.data.success) {
          // if(res.data.result.querySystemList.length > 0){
            that.tableDataSys = res.data.result ? res.data.result.records : []
            that.systemStockPage.pageTotal = res.data.result ? res.data.result.total : 0
          // }
          // if(res.data.result.queryWhList.length > 0){
            // that.tableDataWh = res.data.result ? res.data.result.queryWhList : [];
            // that.whStockPage.pageTotal = res.data.result ? res.data.result.whCountTotal : 0;
          // }
        }
      }).finally(() => {
        that.loading = false;
      });
    },
    getWhGoodsList(page) {
      this.loading = true;
      const that = this
      that.queryParam.pageNo = page.currentPage
      that.queryParam.pageSize = page.pagesize
      that.queryParam.whIds = that.$store.state.userInfo.id,
      getAction(that.url.queryWhProductsPage, that.queryParam).then((res) => {
        if (res.data.success) {
            that.tableDataWh = res.data.result ? res.data.result.queryWhList : [];
            that.whStockPage.pageTotal = res.data.result ? res.data.result.whCountTotal : 0;
        }
      }).finally(() => {
        that.loading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  margin-top: 1%;
  font-size: 14px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
}
.el-cascader {
  display: block;
}
</style>
